import { shopConfig } from "./shopConfig";

export default shopConfig.platform === "nexus";



// WEBPACK FOOTER //
// ./src/helpers/isNexusPlatform.ts